"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Col = _interopRequireDefault(require("react-bootstrap/Col"));
var _Row = _interopRequireDefault(require("react-bootstrap/Row"));
var _Container = _interopRequireDefault(require("react-bootstrap/Container"));
require("./index.css");
var _axios = _interopRequireDefault(require("axios"));
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */

/*
 * Footer used across all the pages
 */

const CustomFooter = props => {
  const ref = (0, _react.useRef)();
  const [isIntersecting, setIntersecting] = (0, _react.useState)(false);
  const [footerInfoData, setFooterInfoData] = (0, _react.useState)(null);
  //loan officer ID
  const loID = props && props.loID || null;
  const queryParams = new URLSearchParams(window.location.search);
  const blof = queryParams.get("blof") || sessionStorage.getItem('blof') || null;
  const queryRlo = queryParams.get("rlo") || sessionStorage.getItem('rlo') || null;
  const rlo = loID ? loID : queryRlo ? queryRlo : null;
  const footerJsonPath = props.footerJsonPath || null;

  //getSWMCReferalLink function  generates a url based on 
  //if rlo or blof values exist. if not, return normal url
  const getSwmcReferralLink = (0, _react.useCallback)(url => {
    let newUrl;
    if (url && rlo && blof) {
      newUrl = `${url}?rlo=${rlo}&blof=${blof}`;
    } else if (url && rlo && !blof) {
      newUrl = `${url}?rlo=${rlo}`;
    } else if (url && !rlo && blof) {
      newUrl = `${url}?blof=${blof}`;
    } else if (url && !rlo && !blof) {
      newUrl = url;
    }
    return newUrl;
  }, [rlo, blof]);
  (0, _react.useEffect)(() => {
    /**
     * Set up the intersection observer once footerInfoData is available
     * and the ref is attached to the DOM element
     */
    if (footerInfoData && ref.current) {
      const observer = new IntersectionObserver(_ref => {
        let [entry] = _ref;
        if (entry.isIntersecting) {
          setIntersecting(entry.isIntersecting);
          observer.disconnect();
        }
      });
      observer.observe(ref.current);

      // Clean up the observer when the component unmounts
      return () => {
        observer.disconnect();
      };
    }
  }, [footerInfoData]);
  (0, _react.useEffect)(() => {
    /**
     * Fetch the footer data
     */
    const fetchSWMCFooterInfo = async () => {
      try {
        const timestamp = Date.now();
        let footerPath;
        if (props.language !== "es") {
          footerPath = process.env.REACT_APP_SWMC_FOOTET_INFO || footerJsonPath;
        } else {
          footerPath = process.env.REACT_APP_SWMC_FOOTET_INFO_SPANISH || footerJsonPath;
        }
        const url = `${footerPath}?timestamp=${timestamp}`;
        await _axios.default.get(url).then(response => {
          setFooterInfoData(response.data);
        }).catch(error => {
          console.log(error);
        });
      } catch (e) {
        console.log(e);
      }
    };
    fetchSWMCFooterInfo();
  }, [props.language, footerJsonPath]);
  (0, _react.useEffect)(() => {
    /**
     * @author Jared Andersen
     * @date 07/31/2024
     * The below function is used to update links in the disclaimer
     * with the rlo query param for any swmc.com links
     * if the rlo or blof is present in the code
     */
    const updateSwmcLinks = () => {
      if (footerInfoData) {
        const links = document.querySelectorAll(".footer_desc_text a");
        links.forEach(element => {
          if ((!element.href.includes("rlo=") || !element.href.includes("blof=")) && element.href.includes("swmc.com")) {
            element.href = getSwmcReferralLink(element.href);
          }
        });
      }
    };
    updateSwmcLinks();
  }, [footerInfoData, getSwmcReferralLink]);
  let date = new Date();
  let currentYear = date.getFullYear();
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("footer", null, footerInfoData ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Container.default, {
    className: "swmcfooter"
  }, /*#__PURE__*/_react.default.createElement(_Row.default, null, /*#__PURE__*/_react.default.createElement(_Col.default, {
    lg: 6,
    md: 6,
    sm: 12,
    xs: 12,
    className: "desctypo"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "logosize"
  }, /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement("div", null, "Loading...")
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: getSwmcReferralLink(footerInfoData.sunWestLogoInfo.url),
    target: "_blank",
    rel: "noreferrer",
    title: footerInfoData.sunWestLogoInfo.title
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: footerInfoData.sunWestLogoInfo.imgPath,
    alt: footerInfoData.sunWestLogoInfo.alt,
    className: "footer_logo",
    loading: "lazy"
  })))), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("div", {
    className: "footer_desc_text"
  }, (0, _htmlReactParser.default)(footerInfoData.disclaimer), props.nydisclaimer && (0, _htmlReactParser.default)(footerInfoData.nyStateWithSunWestDisclaimer))), /*#__PURE__*/_react.default.createElement(_Col.default, {
    md: {
      span: 6,
      offset: 0
    },
    lg: 6,
    sm: 12,
    xs: 12,
    className: "contactus"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "contact_block"
  }, /*#__PURE__*/_react.default.createElement("h4", null, (0, _htmlReactParser.default)(footerInfoData.contactUs.heading)), /*#__PURE__*/_react.default.createElement("div", {
    className: "ul_footer address"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "contactflex",
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement("div", null, "Loading...")
  }, /*#__PURE__*/_react.default.createElement("img", {
    style: {
      width: "20px",
      height: "20px",
      marginTop: "4px"
    },
    src: footerInfoData.contactUs.address.imgPath,
    alt: footerInfoData.contactUs.address.alt,
    loading: "lazy"
  })), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
    style: {
      color: "#fff"
    },
    target: "_blank",
    href: footerInfoData.contactUs.address.googleMapsUrl,
    rel: "noreferrer"
  }, footerInfoData.contactUs.address.fullAddress))), /*#__PURE__*/_react.default.createElement("div", {
    className: "contactOptions"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "contactflex",
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement("div", null, "Loading...")
  }, /*#__PURE__*/_react.default.createElement("img", {
    style: {
      width: "20px",
      height: "20px",
      marginTop: "4px"
    },
    src: footerInfoData.contactUs.phone.imgPath,
    alt: footerInfoData.contactUs.phone.alt,
    loading: "lazy"
  })), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "tel:" + footerInfoData.contactUs.phone.phoneNumberWithIntlCode,
    style: {
      color: "#fff"
    }
  }, footerInfoData.contactUs.phone.phoneNumber))), /*#__PURE__*/_react.default.createElement("div", {
    className: "emailfooter"
  }, /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement("div", null, "Loading...")
  }, /*#__PURE__*/_react.default.createElement("img", {
    style: {
      width: "20px",
      height: "20px",
      marginTop: "4px"
    },
    src: footerInfoData.contactUs.email.imgPath,
    alt: footerInfoData.contactUs.email.alt,
    loading: "lazy"
  })), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "mailto:" + footerInfoData.contactUs.email.email,
    style: {
      color: "#fff"
    }
  }, footerInfoData.contactUs.email.email)))))))), /*#__PURE__*/_react.default.createElement(_Row.default, null)), /*#__PURE__*/_react.default.createElement("hr", {
    style: {
      borderTop: "1px solid #fff",
      opacity: "unset"
    }
  }), /*#__PURE__*/_react.default.createElement(_Container.default, null, /*#__PURE__*/_react.default.createElement(_Row.default, {
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "connectwithUs_block"
  }, /*#__PURE__*/_react.default.createElement("h3", null, footerInfoData.connectWithUs.heading))), /*#__PURE__*/_react.default.createElement(_Row.default, {
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_Col.default, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "social_footer"
  }, footerInfoData.connectWithUs.socialMediaLinks.map((socialMediaLinksData, i) => /*#__PURE__*/_react.default.createElement("a", {
    key: i,
    href: socialMediaLinksData.url,
    target: "_blank",
    rel: "noreferrer",
    title: socialMediaLinksData.title
  }, /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement("div", null, "Loading...")
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "marginImg",
    style: {
      margin: "15px 30px 10px 30px"
    },
    src: socialMediaLinksData.imgPath,
    alt: socialMediaLinksData.alt,
    width: "52px",
    height: "52px",
    loading: "lazy"
  })))))))), /*#__PURE__*/_react.default.createElement("hr", {
    style: {
      borderTop: "1px solid #fff",
      opacity: "unset"
    }
  }), /*#__PURE__*/_react.default.createElement(_Container.default, null, /*#__PURE__*/_react.default.createElement(_Row.default, null, /*#__PURE__*/_react.default.createElement(_Col.default, {
    lg: 12,
    xl: 12,
    sm: 12,
    md: 8,
    xs: 12,
    className: "coloflogo"
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap"
    },
    className: "mobilelog"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("a", {
    href: footerInfoData.companyAwards.bestinBusiness.url,
    target: "_blank",
    rel: "noreferrer",
    title: footerInfoData.companyAwards.bestinBusiness.title
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: footerInfoData.companyAwards.bestinBusiness.imgPath,
    className: "bestbixnew",
    alt: footerInfoData.companyAwards.bestinBusiness.alt,
    title: footerInfoData.companyAwards.bestinBusiness.title,
    width: "120px",
    height: "128px",
    loading: "lazy"
  }))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("img", {
    src: footerInfoData.companyAwards.sunWestGreatPlaceToWork.imgPath,
    className: "GTP",
    alt: footerInfoData.companyAwards.sunWestGreatPlaceToWork.alt,
    width: "106px",
    height: "150px",
    title: footerInfoData.companyAwards.sunWestGreatPlaceToWork.title,
    loading: "lazy"
  })), footerInfoData.companyAwards.fastcologo && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("a", {
    href: footerInfoData.companyAwards.fastcologo.url,
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: footerInfoData.companyAwards.fastcologo.imgPath,
    className: "top50new",
    width: "107px",
    height: "102px",
    alt: footerInfoData.companyAwards.fastcologo.alt,
    title: footerInfoData.companyAwards.fastcologo.title,
    loading: "lazy"
  }))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("a", {
    href: footerInfoData.companyAwards.bbbRating.url,
    target: "_blank",
    rel: "noreferrer",
    title: footerInfoData.companyAwards.bbbRating.title
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: footerInfoData.companyAwards.bbbRating.imgPath,
    className: "bbbnew",
    alt: footerInfoData.companyAwards.bbbRating.alt,
    loading: "lazy",
    width: "153px",
    height: "75px"
  }))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("a", {
    href: footerInfoData.companyAwards.bcaRating.url,
    target: "_blank",
    rel: "noreferrer",
    title: footerInfoData.companyAwards.bcaRating.title
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: footerInfoData.companyAwards.bcaRating.imgPath,
    className: "alliancenew",
    alt: footerInfoData.companyAwards.bcaRating.alt,
    loading: "lazy",
    width: "111px",
    height: "63px"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    ref: ref,
    className: "birdeyeContainernew"
  }, isIntersecting ? /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement("div", null, "Loading...")
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: footerInfoData.companyAwards.birdEyeReviews.url,
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/_react.default.createElement("iframe", {
    name: "bfiframe",
    title: "birdeye",
    className: "reviewIcon",
    src: (0, _htmlReactParser.default)(footerInfoData.companyAwards.birdEyeReviews.iframeUrl),
    id: "bfpublish",
    scrolling: "no",
    style: {
      borderWidth: "0px",
      display: "block",
      overflow: "hidden",
      frameborder: "0",
      height: "75px"
    }
  })), /*#__PURE__*/_react.default.createElement("p", {
    style: {
      textAlign: "center"
    },
    className: "birdeye"
  }, "Powered by", " ", /*#__PURE__*/_react.default.createElement("a", {
    href: footerInfoData.companyAwards.birdEyeReviews.poweredByUrl,
    target: "_blank",
    rel: "noreferrer"
  }, "Birdeye"))) : /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: "165px",
      height: "113px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  }, "Birdeye")), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("a", {
    href: footerInfoData.companyAwards.forbesCouncils.url,
    target: "_blank",
    rel: "noreferrer",
    title: footerInfoData.companyAwards.forbesCouncils.title
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: footerInfoData.companyAwards.forbesCouncils.imgPath,
    className: "fbciconnew",
    alt: footerInfoData.companyAwards.forbesCouncils.alt,
    loading: "lazy",
    width: "111px",
    height: "92px"
  }))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("img", {
    src: footerInfoData.companyAwards.equalHousingOpportunity.imgPath,
    alt: footerInfoData.companyAwards.equalHousingOpportunity.alt,
    title: footerInfoData.companyAwards.equalHousingOpportunity.title,
    className: "homiconnew img-fluid",
    loading: "lazy",
    width: "79px",
    height: "89px"
  }))))), /*#__PURE__*/_react.default.createElement(_Row.default, null, /*#__PURE__*/_react.default.createElement(_Col.default, {
    lg: 12,
    className: "coloflogo"
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap"
    },
    className: "mobilelog"
  }, props.showequalOpportunityLogo && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("img", {
    src: footerInfoData.companyAwards.equalOpportunityEmployer.imgPath,
    alt: footerInfoData.companyAwards.equalOpportunityEmployer.alt,
    title: footerInfoData.companyAwards.equalOpportunityEmployer.title,
    className: "equalopprtunity img-fluid",
    loading: "lazy",
    width: "",
    height: ""
  })), props.showTacanewLogo && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("a", {
    href: footerInfoData.companyAwards.autismHeroes.url,
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: footerInfoData.companyAwards.autismHeroes.imgPath,
    title: footerInfoData.companyAwards.autismHeroes.title,
    alt: footerInfoData.companyAwards.autismHeroes.alt,
    className: "Tacanew",
    width: "200px",
    height: "30px",
    loading: "lazy"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "cellLogoDiv",
    style: {
      display: "contents"
    }
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: footerInfoData.companyAwards.poweredByCelligence.url,
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "cellLogoImgnew",
    src: footerInfoData.companyAwards.poweredByCelligence.imgPath,
    title: footerInfoData.companyAwards.poweredByCelligence.title,
    alt: footerInfoData.companyAwards.poweredByCelligence.alt,
    loading: "lazy",
    width: "240px",
    height: "43px"
  }))))))), /*#__PURE__*/_react.default.createElement("hr", {
    style: {
      borderTop: "1px solid #fff",
      opacity: "unset",
      marginBottom: "unset"
    }
  }), /*#__PURE__*/_react.default.createElement(_Container.default, {
    className: "footer_link_banner"
  }, /*#__PURE__*/_react.default.createElement(_Row.default, {
    className: "footcont"
  }, /*#__PURE__*/_react.default.createElement(_Col.default, {
    xl: 4,
    sm: 12,
    className: "padleft0 copyrighttxt"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: props.language !== "es" ? "ul_footer footer_list linklist_en" : "ul_footer footer_list linklist_es",
    style: {
      textAlign: "left"
    }
  }, "\xA9 ", currentYear, " Sun West Mortgage Company, Inc.", " ", props.language !== "es" ? " All Rights Reserved" : "Todos los derechos Reservados")), /*#__PURE__*/_react.default.createElement(_Col.default, {
    xl: 8,
    sm: 12,
    className: "padleft0 padright0 dislinks"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: props.language !== "es" ? "ul_footer footer_list linklist linklist_en" : "ul_footer footer_list linklist linklist_es"
  }, footerInfoData.footerLinks.map((footerLinksData, j) => {
    let url = footerLinksData.url;
    if (!footerLinksData.url.includes("angelai") && !footerLinksData.url.includes("econsent")) {
      url = getSwmcReferralLink(url);
    }
    return /*#__PURE__*/_react.default.createElement("li", {
      key: j
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: url,
      style: {
        color: "#fff"
      },
      title: footerLinksData.title,
      target: "_blank",
      rel: "noreferrer"
    }, footerLinksData.name));
  })))))) : ""));
};
var _default = exports.default = CustomFooter;